import { useCallback } from "react";
import {
    useReportTemplateSettings,
    useSaveReportTemplateSettingsMutation,
} from "@api/reportTemplate.api";
import { ReportSettingsDraftChange } from "./reportSettingsDrafts";
import { useDraftsFor } from "./useReportSettingsDrafts";

export const useTemplateReportSettingsDrafts = ({
    templateId,
}: {
    templateId: string;
}) => {
    const { data } = useReportTemplateSettings(templateId);
    const { mutateAsync, isPending } =
        useSaveReportTemplateSettingsMutation(templateId);
    const save = useCallback(
        (changes: ReportSettingsDraftChange[]) =>
            mutateAsync({
                changes: changes.map(({ reportKey, fields }) => ({
                    reportKey,
                    fields,
                })),
            }),
        [mutateAsync],
    );
    return useDraftsFor({ rows: data?.rows, save, isSaving: isPending });
};
